import { LatestSplit } from 'types/splits.types';
import { ContentContainerType } from 'types/enums';
import { ContentContainer } from 'app/components/Core/ChakraContentContainer';
import { useAppSelector } from 'app/store';
import {
  getReleaseVersion,
  getVersionSyncStatus,
} from 'app/store/Releases/selectors';
import { SlimBanner } from 'app/components/SlimBanner';
import { ChakraEmptyList } from 'app/components/Core';
import { ReleaseActions } from '../ReleaseActions';
import { VersionSplitsTable } from './VersionSplitsTable';

export const VersionSplits = () => {
  const version = useAppSelector(getReleaseVersion);
  const syncState = useAppSelector((state) =>
    getVersionSyncStatus(state, version?.song.versionGuid || '')
  );

  const split = version?.split?.snapshot as LatestSplit;
  const members = Object.values(split?.members || {}).map((member) => ({
    ...member,
    share: Number(member.share ? +member.share / 100 : 0).toFixed(2),
  }));

  const invalid = version?.validationErrors?.some(
    ({ errorCode }) => errorCode === 'INVALID_SPLIT'
  );

  return (
    <ContentContainer
      type={ContentContainerType.LIST}
      centerContent={!split}
      mb={24}
    >
      <ReleaseActions tab="splits" syncState={syncState} />
      {invalid && (
        <SlimBanner
          variant="warning"
          primaryText="Credit removed. Please propose a new Split."
          mb={6}
        />
      )}
      {members.length === 0 ? (
        <ChakraEmptyList
          title="No split for this Song."
          primaryText="You can add split in the Song and then Sync for this release and all information will be fetched."
        />
      ) : (
        <VersionSplitsTable />
      )}
    </ContentContainer>
  );
};
